import * as React from 'react'

import { Button, ModalDialogType } from '@factorialco/deprecated-design-system'
import { F0Box, F0Button, F0Heading, F0Text } from '@factorialco/f0-react'

import Dialog from 'modules/core/components/Modal/Dialog'
import i18n from 'modules/core/lib/i18n'

import './index.styles.css'
import './PdfViewerF0.styles.css'
interface Props {
  onSubmit: () => void
  useF0?: boolean
}

const EnableEditModal = ({ onSubmit, useF0 = false }: Props) => {
  if (useF0) {
    return (
      <div className={'PdfViewerF0_modalContainerF0'}>
        <F0Box padding="lg" gap="md" background="primary" borderRadius="lg" border="default">
          <F0Heading variant="heading" content={i18n.t('documents.viewer.editModal.title')} />
          <F0Text variant="body" content={i18n.t('documents.viewer.editModal.description')} />
          <F0Box display="flex" flexDirection="row" justifyContent="end" paddingTop="sm">
            <F0Button onClick={onSubmit} label={i18n.t('documents.viewer.editModal.action')} />
          </F0Box>
        </F0Box>
      </div>
    )
  }

  return (
    <div className={'PdfViewer_modalContainer'}>
      <Dialog
        type={ModalDialogType.Regular}
        title={i18n.t('documents.viewer.editModal.title')}
        description={i18n.t('documents.viewer.editModal.description')}
        onSubmit={onSubmit}
        footer={<Button submit>{i18n.t('documents.viewer.editModal.action')}</Button>}
        locked
      />
    </div>
  )
}

export default EnableEditModal
